import { render, staticRenderFns } from "./BE.IN.vue?vue&type=template&id=4091af64&scoped=true&"
import script from "./BE.IN.vue?vue&type=script&lang=ts&"
export * from "./BE.IN.vue?vue&type=script&lang=ts&"
import style0 from "./BE.IN.vue?vue&type=style&index=0&id=4091af64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4091af64",
  null
  
)

export default component.exports